export default {
    "fr": {
        "or": "ou",
        "Edit": "Modifier",
        "Close": "Fermer",
        "Update": "Mettre à jour",
        "Save": "Enregistrer",
        "days": {
            "mo": "Lundi",
            "tu": "Mardi",
            "we": "Mercredi",
            "th": "Jeudi",
            "fr": "Vendredi",
            "sa": "Samedi",
            "su": "Dimanche"
        },
        "count goods": "1 marchandise ::: {count} marchandises",
        "count days": "1 jour ::: {count} jours",
        "An error has occured": "Une erreur est survenue."
    }
}
